import { render } from "./SaveConfirmation.vue?vue&type=template&id=84aebb2c&scoped=true&ts=true"
import script from "./SaveConfirmation.vue?vue&type=script&lang=ts"
export * from "./SaveConfirmation.vue?vue&type=script&lang=ts"

import "./SaveConfirmation.vue?vue&type=style&index=0&id=84aebb2c&scoped=true&lang=css"

import exportComponent from "/home3/sli/web/public/resources/editorvue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84aebb2c"]])

export default __exports__